import { SubpageContentBlocks } from "@components/page/SubpageContentBlocks"
import { SingleContentBlock } from "eddev/blocks"
import { defineView } from "eddev/views"
import { Suspense } from "react"

export const meta: ViewMeta = {
  templateName: "Homepage",
}

export default defineView("template-home", (props) => {
  const carousel = props.page?.contentBlocks.find((b) => b.slug === "homepage/homepage-carousel")
  const rest = props.page?.contentBlocks.filter((b) => b.slug !== "homepage/homepage-carousel")
  return (
    <div className="theme-dark bg-bg" data-mixpanel-template="Homepage">
      <SingleContentBlock block={carousel!} />
      <div className="bg-bg relative z-[1] [&>*:first-child]:!mt-0 pt-5">
        <Suspense>
          <SubpageContentBlocks blocks={rest} />
        </Suspense>
        <div className="h-10" />
      </div>
    </div>
  )
})
